import Axios, { AxiosRequestConfig } from 'axios';

import { IHttpClient } from './models';

class HttpClient implements IHttpClient {
    private baseUrl: string = process.env.NODE_ENV !== 'production' ? 'https://scout.llc/api' : '/api';

    constructor () {
        Axios.interceptors.response.use(async (config) => {
            return config.data;
        });
    }

    public get<res> (url: string, configs?: AxiosRequestConfig): Promise<res> {
        return Axios.get(`${this.baseUrl}/${url}`, configs);
    }

    public post<res, req> (url: string, data: req, configs?: AxiosRequestConfig): Promise<res> {
        return Axios.post(`${this.baseUrl}/${url}`, data, configs);
    }

    public put<res, req> (url: string, data: req, configs?: AxiosRequestConfig): Promise<res> {
        return Axios.put(`${this.baseUrl}/${url}`, data, configs);
    }

    public delete<res> (url: string, configs?: AxiosRequestConfig): Promise<res> {
        return Axios.delete(`${this.baseUrl}/${url}`, configs);
    }
}

export const httpClient = new HttpClient();
